import React, { useState, useEffect, useRef } from 'react';

export default function ParaphraseOutput({ text }) {
    const [displayedText, setDisplayedText] = useState("");
    const animationRef = useRef(null);
    const textRef = useRef(text);

    useEffect(() => {
        textRef.current = text;
        setDisplayedText("");
        
        if (!text) return;

        let index = 0;
        const typeCharacter = () => {
            if (index < textRef.current.length) {
                setDisplayedText(prev => prev + textRef.current.charAt(index));
                index++;
                animationRef.current = setTimeout(typeCharacter, 30);
            }
        };

        typeCharacter();

        return () => {
            if (animationRef.current) {
                clearTimeout(animationRef.current);
            }
        };
    }, [text]);

    return (
        <textarea id='topicsInput'
            value={displayedText}
            readOnly
            style={{ 
                minHeight: "150px", 
                width: "100%",
                whiteSpace: "pre-wrap" 
            }}
        />
    );
}